<script lang="ts" generics="T extends object">
  import type { Column } from './table-types.js';

  let {
    rows,
    columns,
    rowKey,
    onRowClick = null,
    empty = 'No data',
    striped = true,
  }: {
    rows: T[];
    columns: Column<T>[];
    rowKey: (row: T) => string | number;
    onRowClick?: ((row: T) => void) | null;
    empty?: string;
    striped?: boolean;
  } = $props();
</script>

<div class="table-wrap">
  <table class:striped>
    <thead>
      <tr>
        {#each columns as c (c.key)}
          <th
            style:width={c.width}
            style:text-align={c.align ?? 'left'}
          >{c.label}</th>
        {/each}
      </tr>
    </thead>
    <tbody>
      {#if rows.length === 0}
        <tr><td class="empty" colspan={columns.length}>{empty}</td></tr>
      {:else}
        {#each rows as row (rowKey(row))}
          <tr
            class:clickable={!!onRowClick}
            onclick={onRowClick ? () => onRowClick(row) : undefined}
          >
            {#each columns as c (c.key)}
              <td style:text-align={c.align ?? 'left'}>
                {c.format ? c.format(row[c.key], row) : String(row[c.key] ?? '')}
              </td>
            {/each}
          </tr>
        {/each}
      {/if}
    </tbody>
  </table>
</div>

<style>
  .table-wrap {
    width: 100%;
    overflow-x: auto;
    background: var(--color-white);
    border: 1px solid var(--color-border);
    border-radius: var(--radius-md);
  }
  table {
    width: 100%;
    border-collapse: collapse;
    font-family: var(--font-ui);
    font-size: var(--text-sm);
    font-variant-numeric: tabular-nums;
  }
  th {
    background: var(--color-surface);
    color: var(--color-text-muted);
    font-weight: var(--weight-semibold);
    font-size: var(--text-xs);
    letter-spacing: var(--tracking-wide);
    text-transform: uppercase;
    padding: 10px 14px;
    border-bottom: 1px solid var(--color-border);
    position: sticky;
    top: 0;
  }
  td {
    padding: 10px 14px;
    border-bottom: 1px solid var(--color-border);
    color: var(--color-text);
  }
  tbody tr:last-child td { border-bottom: none; }
  .striped tbody tr:nth-child(even) td { background: var(--color-surface); }
  tr.clickable { cursor: pointer; }
  tr.clickable:hover td { background: var(--color-info-bg); }
  .empty {
    text-align: center;
    color: var(--color-text-muted);
    padding: var(--space-2xl);
  }
</style>
